@if (product) {
  <mat-tab-group  class="pdp-MatGroup" animationDuration="0ms">
    @if (product?.generalInfoMap?.length>0) {
      <mat-tab [label]="product?.generalInfoTabLabel || 'General Info'"> <app-general-info-tab
      [product]="product"></app-general-info-tab></mat-tab>
    }
    @if (product?.untypedFeatures?.length>0) {
      <mat-tab [label]="product?.technicalAttributeTabLabel || 'Technical Attributes '"><app-technical-attributes-tab
      [product]="product"></app-technical-attributes-tab></mat-tab>
    }
    @if (product?.kbEcomDocuments?.length>0) {
      <mat-tab [label]="product?.documentTabLabel || 'Documents & Videos'"><app-documents-tab
      [product]="product"></app-documents-tab></mat-tab>
    }
    @if (product?.alternativeReference?.length>0) {
      <mat-tab [label]="product?.closestEquivalentTabLabel || 'Closest Equivalent Product'"><app-closet-equivent-tab
      [product]="product"></app-closet-equivent-tab></mat-tab>
    }
  </mat-tab-group>
}
